import GalleryModal, { ImageData } from 'components/GalleryModal'
import { toLongDate, toShortDate, toTime } from 'utils/date'
import { closeThread, selectChatThread } from './chatSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import SocketContext from 'context/socket/SocketContext'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useParams } from 'react-router-dom'
import { Fragment, useContext } from 'react'
import Message from './Message'
import Input from './Input'

interface Popup {
  type: 'gallery'
  content: chat.NewFile[]
  index: number
}

const currentDate = new Date()
const Messages: React.FC = () => {
  const { popup } = usePopupState()
  const { id } = useParams<{ id: string }>()
  const userId = useReduxSelector(selectUserId)
  const data = useReduxSelector(state => selectChatThread(state, id))

  const { t, lang } = useTranslation('chat')
  const dispatch = useReduxDispatch()
  const { sendMessage } = useContext(SocketContext)
  const closeChat = () => {
    sendMessage({ command: 'closeChat', payload: { userId, chat_id: id } })
    dispatch(closeThread({ chatId: id }))
  }

  return (
    <>
      {!!popup && (popup as Popup)?.type === 'gallery' && <GalleryModal
        initialSlide={(popup as Popup).index}
        data={(popup as Popup).content.reduce((r, item) => {
          if (item.is_image) {
            r.push(item)
          }
          return r
        }, [] as ImageData[])}
      />}

      {id
        ? <>
          <div className='chat__header'>
            <div className='--secFont'>{data?.name || t('conversationWithAConsultant')}</div>
            <p>{t('started')}: {toLongDate(data?.started_at || Date.now(), lang)}</p>
          </div>

          <div className='chat__list --high'>
            <div>
              <p>{toShortDate((data?.messages && data?.messages?.length > 0) ? data.messages[0].datetime : currentDate, lang)}</p>
              {(!data?.messages || !!data?.messages?.[0]?.receiverRoom) && <div className='chat__message --service'>
                <div className='message__desc'>{t('hiHowCanWeHelpYou')}</div>
                <div className='message__time'>{toTime(currentDate, lang)}</div>
              </div>}
              {data?.messages?.map((message, idx, arr) => {
                const showDate = !idx ? false : arr[idx - 1].datetime?.substring(0, 10) !== message.datetime?.substring(0, 10)
                const date = new Date(message.datetime)
                return <Fragment key={id}>
                  {showDate && <p>{toShortDate(date, lang)}</p>}
                  <Message
                    {...message}
                    chatId={id}
                    date={date}
                  />
                </Fragment>
              })}

              {data
                ? data.closed_at
                  ? <p>{t('completed')}: {toLongDate(data.closed_at, lang)}</p>
                  : <p onClick={closeChat}>{t('closeChat')}</p>
                : null}
            </div>
          </div>

          <Input
            chat_id={id}
            disabled={!!data?.closed_at}
          />
        </>
        : <div className='chat__list center --high'>
          <h3>{t('selectChat')}</h3>
        </div>}
    </>
  )
}

export default Messages